var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPartneringShelters(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("ellipse", {
    fill: "none",
    stroke: "#f29e41",
    strokeWidth: 0.9765,
    strokeMiterlimit: 10,
    cx: 32.051998,
    cy: 32.102001,
    rx: 31.292999,
    ry: 31.200001,
    id: "ellipse1",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#f29e41",
    strokeWidth: 1.0915,
    strokeMiterlimit: 10,
    d: "M 37.037,21.419",
    id: "path1",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#F29E41",
    strokeWidth: 1.0915,
    strokeMiterlimit: 10,
    points: "22.095,36.809 39.961,19.336    57.727,36.809  ",
    id: "polyline1",
    style: {
      stroke: "#ff6501",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#F29E41",
    strokeWidth: 1.0915,
    strokeMiterlimit: 10,
    points: "25.7,33.283 25.7,51.936    53.848,51.936 53.848,33.283  ",
    id: "polyline2",
    style: {
      stroke: "#ff6501",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F29E41",
    stroke: "#F29E41",
    strokeMiterlimit: 10,
    d: "M44.322,39.63c0-3.819-8.979-3.716-8.979,0   c0,1.707,0,11.675,0,11.675h8.979C44.322,51.305,44.322,41.177,44.322,39.63z",
    id: "path2",
    style: {
      fill: "#ff6501",
      fillOpacity: 1,
      stroke: "#ff6501",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3_copy",
    style: {
      display: "inline"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#f29e41",
    strokeWidth: 1.0915,
    strokeMiterlimit: 10,
    d: "M 18.26,12.484",
    id: "path3"
  })), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#f29e41",
    strokeWidth: 1.0915,
    strokeMiterlimit: 10,
    points: "3.317,27.873 21.184,10.401    35.102,24.089  ",
    id: "polyline3",
    style: {
      stroke: "#ff6501",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#f29e41",
    strokeWidth: 1.0915,
    strokeMiterlimit: 10,
    points: "6.922,24.348 6.922,43 25.7,43  ",
    id: "polyline4",
    style: {
      stroke: "#ff6501",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f29e41",
    stroke: "#f29e41",
    strokeMiterlimit: 10,
    d: "m 25.545,30.694 c 0,-3.819 -8.979,-3.716 -8.979,0 0,1.707 0,11.675 0,11.675 h 8.979 c 0,0 0,-10.128 0,-11.675 z",
    id: "path4",
    style: {
      stroke: "#ff6501",
      strokeOpacity: 1,
      fill: "#ff6501",
      fillOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartneringShelters);
export default __webpack_public_path__ + "static/media/partneringShelters.fb333a46affa4107c2405c9ca959ff84.svg";
export { ForwardRef as ReactComponent };